import { buildApiUrl } from "./apiClientService";

async function getJson(path) {
  const res = await fetch(buildApiUrl(path), { credentials: "omit" });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.message || "Could not load content");
  return data;
}

export async function fetchBannersPublic() {
  const data = await getJson("/api/platform/banners");
  return Array.isArray(data.banners) ? data.banners : [];
}

export async function fetchAnnouncementsPublic(vendorId = null) {
  const url = vendorId
    ? `/api/platform/announcements?vendorId=${encodeURIComponent(vendorId)}`
    : "/api/platform/announcements";
  const data = await getJson(url);
  return Array.isArray(data.announcements) ? data.announcements : [];
}

export async function fetchLegalPagePublic(slug) {
  const cleanSlug = String(slug || "").replace(/^\/+/, "");
  const data = await getJson(`/api/platform/pages/${encodeURIComponent(cleanSlug)}`);
  return data.page || null;
}
